<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="500" persistent @input="close">
      <v-card>
        <DialogCardTitle title="Скачать файлы" @close="close" />

        <v-card-text class="pa-6">
          <v-list max-height="400" class="overflow-y-auto">
            <v-list-item v-for="file of filesList" :key="file.id">
              <v-list-item-content>{{ file.originalName }}</v-list-item-content>
              <v-list-item-action>
                <v-icon
                  class="uikit-icon file-text primary-h size-20" title="Скачать файлы"
                  @click="downloadFile(file)"
                />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions class="px-6 pt-0 pb-5 d-flex justify-center">
          <div class="d-flex d-inline-flex">
            <v-btn
              color="primary" outlined
              class="px-4 d-flex align-center"
              @click="close"
            >
              <v-icon class="uikit-icon close primary" />
              <span class="pl-3 btn-text">Закрыть</span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogCardTitle from '@/ui/dialog/DialogCardTitle'
import { userFileValueApi, fileApi } from '@/api'
import download from '@/plugins/download'

export default {
  name: 'DownloadFilesDialog',

  components: { DialogCardTitle },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    fieldValueId: {
      type: Number,
      default: null,
    },
  },

  mounted() {

  },

  data: () => ({ filesList: [] }),

  methods: {
    async getAllFiles() {
      try {
        const data = await userFileValueApi.get(this.fieldValueId)
        this.filesList = data.files
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения файлов')
      }
    },

    async downloadFile(item) {
      try {
        const data = await fileApi.getFile(item.id)
        download(data, item.originalName)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      }
    },

    close() {
      this.$emit('close')
    },
  },

  watch: {
    fieldValueId(val) {
      !!val && this.getAllFiles()
    },
  },
}
</script>
